import { render, staticRenderFns } from "./CrmOrderDetail.vue?vue&type=template&id=126b7736&scoped=true"
import script from "./CrmOrderDetail.vue?vue&type=script&lang=js"
export * from "./CrmOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./CrmOrderDetail.vue?vue&type=style&index=0&id=126b7736&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126b7736",
  null
  
)

export default component.exports